module.exports = __webpack_public_path__ + "static/media/portfolio_site_bridge_1.a6d6a176.png";